import { RouteType } from 'types/RouteType';
import { RootStore } from 'stores/index';

const createJobRoute: RouteType = {
  name: 'Job Management',
  path: '/admin/job-management',
  layout: '/admin',
  viewportCard: {
    header: {
      title: 'Job Management',
      enableBackButton: true,
      color: 'primary',
      component: () => import('./CreateJob.Header'),
    },
    body: {
      component: () => import('./CreateJob.Body'),
      grayBackground: false,
    },
  },
  group: 'Administration',
  requiresAuth: true,
  requiresAdmin: true,
  requiresPermission: false,
  beforeEnter: async ({ rootStore }: { rootStore: RootStore }) => {
    // Pre-load all projects
    const projectsStore = rootStore.projectsStore as {
      find?: (query: Record<string, unknown>) => Promise<void>;
    };
    if (projectsStore?.find) {
      await projectsStore.find({ query: { $limit: 500 } });
    }
    return true;
  },
};

export default createJobRoute;
